export const VERSION_ID_PARAM = 'version-id';

export const languageLabels = {
	nb: 'Norsk (bokmål)',
	nn: 'Norsk (nynorsk)',
	en: 'English',
	se: 'Sámegiel (samisk)',
	pl: 'Polski (polsk)',
	uk: 'Українська (ukrainsk)',
	ru: 'Русский (russisk)',
};

export const CONSUMER = 'dekoratoren';
